import {
    SHOW_LOGIN,
    HIDE_LOGIN,
    SHOW_LOGIN_SPINNER,
    HIDE_LOGIN_SPINNER,
    SET_LOGIN_OFFSET_TOP,
    SET_LOGIN_SPINNER_ORIGIN,
    HIDE_SSO_EMAIL_ERROR_MODAL,
    SHOW_SSO_EMAIL_ERROR_MODAL,
} from '../constants/ActionTypes';

export const getInitialState = () => ({
    isLoginShown: false,
    isLoading: false,
    offsetTop: null,
    spinnerOrigin: null,
    showSsoModal: false,
    errorEmail: '',
});

export default (state = getInitialState(), action = null) => {
    switch (action.type) {
    case SHOW_LOGIN:
        return {
            ...state,
            isLoginShown: true,
        };
    case HIDE_LOGIN:
        return {
            ...state,
            isLoginShown: false,
            offsetTop: null,
            spinnerOrigin: null,
        };
    case SHOW_LOGIN_SPINNER:
        return {
            ...state,
            isLoading: true,
        };
    case HIDE_LOGIN_SPINNER:
        return {
            ...state,
            isLoading: false,
        };
    case SET_LOGIN_OFFSET_TOP:
        return {
            ...state,
            offsetTop: action.payload,
        };
    case SET_LOGIN_SPINNER_ORIGIN:
        return {
            ...state,
            spinnerOrigin: action.payload,
        };
    case HIDE_SSO_EMAIL_ERROR_MODAL:
        return {
            ...state,
            showSsoModal: false,
            errorEmail: '',
        };
    case SHOW_SSO_EMAIL_ERROR_MODAL:
        return {
            ...state,
            showSsoModal: true,
            errorEmail: action.payload,
        };
    default:
        return state;
    }
};
